import { useState, useContext, useEffect } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import UserContext from "../UserContext";
import "./Register.css";
import "../styles/login.css";
import Logoname from "../img/logo/logo-name.png";
import ImgPhone from "../img/site/phone.png";
import LoginFooter from "../Components/LoginFooter";
import AppStore from "../img/logo/app-store.png";
import PlayStore from "../img/logo/google-play.png";
import { LoadingOutlined } from "@ant-design/icons";
import SEO from "../Components/SEO";

export default function HomeChangePassword() {
  const { user, mode, changePassword } = useContext(UserContext);
  const [newPassword, setNewpassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const history = useHistory();

  if (user.token) {
    history.push("/");
  }
  const handleConfirmPassword = (e) => {
    setConfirmPassword(e.target.value);
  };
  const handleNewPassword = (e) => {
    setNewpassword(e.target.value);
  };

  const location = useLocation();
  const changeUserPassword = async (e) => {
    e.preventDefault();
    if (newPassword === confirmPassword) {
      let token = location.search.split("?q=")[1];
      setLoading(true);
      let { message, success, error } = await changePassword("reset", {
        new_password: newPassword,
        token,
      });
      if (success) {
        window.Toast.fire({
          icon: "success",
          title: message || "Worked as expected",
        });
        history.push("/login");
      } else {
        window.displayToastError(error);
      }
      setLoading(false);
    } else {
      window.displayToastError("Passwords don't match");
    }
  };
  // setting the theme
  const [dark, setDark] = useState(false);
  useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);
  return (
    <>
      <SEO title="Change Password"></SEO>
      <div className={dark ? "w-full darkmode" : "w-full"}>
        <div className="">
          <div className="lg:flex gap-5 justify-center">
            <div className="w-1/4  hidden lg:block">
              <div className="flex justify-center">
                <img src={ImgPhone} alt="Twika showcase" />
              </div>
            </div>

            <div className="lg:w-1/4 p-0 mt-100">
              <div className="form-container border">
                <div className="logo-name w-full flex justify-center">
                  <img src={Logoname} alt="Our logo name" />
                </div>
                <div className="inputs-group">
                  <p className="my-2">Reset your password here</p>
                  <form onSubmit={changeUserPassword}>
                    <div className="form-group">
                      <input
                        autoComplete="off"
                        type="password"
                        id="password1"
                        placeholder="New Password"
                        value={newPassword}
                        onChange={handleNewPassword}
                        className="form-control"
                      />
                    </div>
                    <div className="form-group">
                      <input
                        autoComplete="off"
                        type="password"
                        id="password2"
                        placeholder="Confirm password"
                        value={confirmPassword}
                        onChange={handleConfirmPassword}
                        className="form-control"
                      />
                    </div>

                    <div className="form-group">
                      {loading ? (
                        <button
                          type="submit"
                          className="p-2 rounded-md bg-fire w-100 text-white opacity-50 gap-1 flex items-center justify-center"
                          style={{ fontSize: "13px" }}
                        >
                          {" "}
                          <LoadingOutlined /> <span>Resetting ...</span>
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className="p-2 rounded-md bg-fire w-100 text-white"
                          style={{ fontSize: "13px" }}
                        >
                          Reset password
                        </button>
                      )}

                      <div className="flex justify-end mt-2 ">
                        <Link
                          to="/login"
                          className="text-gray-500 hover:underline"
                        >
                          Remember password
                        </Link>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div className="border mt-1 p-1 flex justify-center items-center">
                <span className="">
                  Don't have any account?{" "}
                  <b>
                    <Link to="/register"> Create One.</Link>
                  </b>
                </span>
              </div>
              {!dark && (
                <div className="mt-1 p-1 form-container">
                  <div className="account2">
                    <div className="app-stores flex w-full justify-center">
                      <img src={AppStore} alt="App Store" className="mr-2" />
                      <img
                        src={PlayStore}
                        alt="Google Play Store"
                        className="ml-2"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <LoginFooter />
      </div>
    </>
  );
}
